<template>
  <div>
    <el-tabs
    type="border-card"
    v-model="activeName"
    >
      <el-tab-pane
      label="查询"
      name="one"
      >
        <!-- 查询表单 -->
        <el-form
        ref="search_form"
        :model="search_form"
        label-width="130px"
        class="search_form"
        >
          <el-form-item label="数据库类型" prop="dataSourceType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.dataSourceType"
            placeholder="请选择"
            clearable
            @change="change_dataSourceType_search"
            >
              <el-option
              v-for="item in dataSourceType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据源" prop="dataSource">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.dataSource"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in dataSource_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报表类型" prop="functionType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.functionType"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in functionType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行类型" prop="executeType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.executeType"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in executeType_list"
              :key="item.value"
              :label="item.text"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报表名称" prop="functionName">
            <el-input placeholder="请输入报表名称" v-model="search_form.functionName"></el-input>
          </el-form-item>
          <el-form-item label="执行名称" prop="executeName">
            <el-input placeholder="请输入执行名称" v-model="search_form.executeName"></el-input>
          </el-form-item>
          <el-form-item label="激活标志" prop="activeFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="search_form.activeFlag"
            placeholder="请选择"
            clearable
            >
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
            type="primary"
            icon="el-icon-search"
            @click="search_manage"
            v-if="btn_permission.includes('middle:customFunction:list')||btn_permission.includes('superAdmin')"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            @click="reset_manage"
            v-if="btn_permission.includes('middle:customFunction:list')||btn_permission.includes('superAdmin')"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
      label="列表"
      name="two"
      >
        <!-- 报表管理列表 -->
        <el-table
        :data="list_data"
        highlight-current-row
        border
        max-height="400"
        ref="db_detail_list"
        @row-dblclick="manage_check_detail"
        >
          <el-table-column
          align="center"
          type="index"
          label="No"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="dataSource"
          label="数据源"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="activeFlag"
          label="激活"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="functionTypeText"
          label="报表类型"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="functionName"
          label="报表名称"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="executeType"
          label="执行类型"
          ></el-table-column>
          <el-table-column
          show-overflow-tooltip
          align="center"
          prop="executeName"
          label="执行名称"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="pageFlag"
          label="是否分页"
          ></el-table-column>
          <el-table-column
          align="center"
          prop="pageSize"
          label="每页数"
          ></el-table-column>
        </el-table>
        <!-- 报表管理列表分页 -->
        <el-pagination
        style="margin: 10px auto;"
        background
        @size-change="manage_size_change"
        @current-change="manage_current_change"
        :current-page="manage_current_page"
        :page-sizes="[10,15,20,25]"
        :page-size="manage_page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="manage_total"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane
      label="明细"
      name="three"
      >
        <!-- 报表管理明细表单 -->
        <el-form
        ref="details_form"
        :model="details_form"
        label-width="130px"
        class="details_form"
        :rules="add_rules"
        >
          <el-divider content-position="left">基础信息</el-divider>
          <el-form-item label="数据库类型" prop="dataSourceType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="details_form.dataSourceType"
            placeholder="请选择"
            clearable
            @change="change_dataSourceType_add"
            >
              <el-option
              v-for="item in dataSourceType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据源" prop="dataSource">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="details_form.dataSource"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in dataSource_sel_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报表类型" prop="functionType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="details_form.functionType"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in functionType_list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="执行类型" prop="executeType">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="details_form.executeType"
            placeholder="请选择"
            clearable
            >
              <el-option
              v-for="item in executeType_list"
              :key="item.value"
              :label="item.text"
              :value="item.value"
              :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报表名称" prop="functionName">
            <el-input placeholder="请输入报表名称" v-model="details_form.functionName"></el-input>
          </el-form-item>
          <el-form-item label="执行名称" prop="executeName">
            <el-input placeholder="请输入执行名称" v-model="details_form.executeName"></el-input>
          </el-form-item>
          <el-form-item label="激活标志" prop="activeFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="details_form.activeFlag"
            placeholder="请选择"
            clearable
            >
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序字段" prop="orderBy">
            <el-input placeholder="例：addTime asc,orderNo desc" v-model="details_form.orderBy"></el-input>
          </el-form-item>
          <el-form-item label="汇总字段" prop="summaryBy">
            <el-input v-model="details_form.summaryBy"></el-input>
          </el-form-item>
          <el-form-item label="报表权限" prop="configAuth">
            <el-input placeholder="如果为空则为通用报表" v-model="details_form.configAuth"></el-input>
          </el-form-item>
          <el-form-item label="是否分页" prop="pageFlag">
            <el-select
            style="width: 100%;"
            :popper-append-to-body="false"
            v-model="details_form.pageFlag"
            placeholder="请选择"
            clearable
            >
              <el-option label="是" value="Y"></el-option>
              <el-option label="否" value="N"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每页数" prop="pageSize">
            <el-input type="number" v-model="details_form.pageSize"></el-input>
          </el-form-item>
          <el-form-item label="导出报表" prop="canExport">
            <el-switch
            v-model="details_form.canExport"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="Y"
            inactive-value="N"
            ></el-switch>
          </el-form-item>
          <el-form-item label="查询语句" prop="sqlData" class="form1_other">
            <el-input :rows="4" type="textarea" v-model="details_form.sqlData"></el-input>
          </el-form-item>
          <el-divider content-position="left">操作信息</el-divider>
          <el-form-item label="创建人" prop="createBy">
            <el-input :readonly="true" v-model="details_form.createBy"></el-input>
          </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
            <el-input :readonly="true" v-model="details_form.createTime"></el-input>
          </el-form-item>
          <el-form-item label="修改人" prop="modifyBy">
            <el-input :readonly="true" v-model="details_form.modifyBy"></el-input>
          </el-form-item>
          <el-form-item label="修改时间" prop="updateTime">
            <el-input :readonly="true" v-model="details_form.updateTime"></el-input>
          </el-form-item>
          <el-form-item class="form1_other">
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-plus"
            :disabled="add_manage_status"
            @click="add_manage"
            v-if="btn_permission.includes('middle:customFunction:add')||btn_permission.includes('superAdmin')"
            >增加</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-edit"
            :disabled="edit_manage_status"
            @click="edit_manage"
            v-if="btn_permission.includes('middle:customFunction:edit')||btn_permission.includes('superAdmin')"
            >修改</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-delete"
            :disabled="delete_manage_status"
            @click="delete_manage"
            v-if="btn_permission.includes('middle:customFunction:del')||btn_permission.includes('superAdmin')"
            >删除</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            type="primary"
            icon="el-icon-delete"
            :disabled="disable_manage_status"
            @click="disable_manage"
            v-if="btn_permission.includes('middle:customFunction:disable')||btn_permission.includes('superAdmin')"
            >禁用</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            icon="el-icon-check"
            :disabled="save_manage_status"
            @click="save_manage"
            >保存</el-button>
            <el-button
            size="mini"
            class="operate_btn"
            icon="el-icon-close"
            :disabled="cancel_manage_status"
            @click="cancel_manage"
            >取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return{
        btn_permission:JSON.parse(localStorage.getItem(localStorage.getItem('userName')+'permission')),
        activeName:'one',
        //数据库类型下拉框
        dataSourceType_list:[
          {
            label:'SQLSERVER',
            value:'SQLSERVER'
          },
          {
            label:'MYSQL',
            value:'MYSQL'
          },
          {
            label:'ORACLE',
            value:'ORACLE'
          }
        ],
        //数据源下拉框
        dataSource_list:[],
        dataSource_sel_list:[],
        //报表类型下拉框
        functionType_list:[],
        //执行类型下拉框
        executeType_list:[],
        //查询表单
        search_form:{
          dataSourceType:'',
          dataSource:'',
          functionType:'',
          executeType:'',
          functionName:'',
          executeName:'',
          activeFlag:''
        },
        //报表管理列表
        list_data:[],
        row_first_now:[],
        //报表管理列表分页
        manage_current_page:1,
        manage_page_size:10,
        manage_total:0,
        //报表管理当前行
        row_manage_now:{},
        //新增或修改表单正则
        add_edit:'',
        add_rules:{
          dataSourceType:[
            {required:true,message:'请选择数据库类型',trigger:'change'}
          ],
          dataSource:[
            {required:true,message:'请选择数据源',trigger:'change'}
          ],
          functionType:[
            {required:true,message:'请选择报表类型',trigger:'change'}
          ],
          executeType:[
            {required:true,message:'请选择执行类型',trigger:'change'}
          ],
          functionName:[
            {required:true,message:'请输入报表名称',trigger:'blur'}
          ],
          executeName:[
            {required:true,message:'请输入执行名称',trigger:'blur'}
          ],
          activeFlag:[
            {required:true,message:'请选择激活状态',trigger:'change'}
          ],
          orderBy:[
            {required:true,message:'请输入排序字段',trigger:'blur'}
          ],
          summaryBy:[
            {required:true,message:'请输入汇总字段',trigger:'blur'}
          ],
          configAuth:[
            {required:true,message:'请输入报表权限',trigger:'blur'}
          ],
          pageFlag:[
            {required:true,message:'请选择是否分页',trigger:'change'}
          ],
          pageSize:[
            {required:true,message:'请输入每页数量',trigger:'blur'}
          ],
          sqlData:[
            {required:true,message:'请输入查询语句',trigger:'blur'}
          ],
        },
        //报表管理明细表单
        details_form:{
          dataSourceType:'',
          dataSource:'',
          functionType:'',
          functionTypeText:'',
          executeType:'',
          functionName:'',
          executeName:'',
          activeFlag:'',
          orderBy:'',
          summaryBy:'',
          configAuth:'',
          pageFlag:'',
          pageSize:'',
          canExport:'',
          sqlData:'',
          createBy:'',
          createTime:'',
          modifyBy:'',
          updateTime:'',
        },
        //报表管理明细表单禁用状态
        add_manage_status:false,
        edit_manage_status:false,
        delete_manage_status:false,
        disable_manage_status:false,
        save_manage_status:true,
        cancel_manage_status:true
      }
    },
    created() {
      let that=this
      that.publicAjax.axios_set()
      //执行类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/middle/custom_function/execute_type'
      }).then(data=>{
        if(data.data.success==true){
          that.executeType_list=data.data.data
        }
      })
      //报表类型下拉框
      that.$axios({
        method:'get',
        url:that.publicAjax.extra_path+'/admin/dict/select/byCode/customFunctionType'
      }).then(data=>{
        if(data.data.success==true){
          that.functionType_list=data.data.data
        }
      })
    },
    mounted() {

    },
    methods:{
      //数组去重
      unique(arr){
        const res=new Map()
        return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
      },
      //数据库类型change事件
      change_dataSourceType_search(value){
        this.get_dataSource(value,'search')
      },
      change_dataSourceType_add(value){
        this.get_dataSource(value,'add')
      },
      get_dataSource(val,type){
        let that=this
        if(val=='MYSQL'){
          if(type=='search'){
            that.dataSource_list=[
              {label:'SCC_WMS',value:'SCC_WMS'}
            ]
          }else{
            that.details_form.dataSource=''
            that.dataSource_sel_list=[
              {label:'SCC_WMS',value:'SCC_WMS'}
            ]
          }
        }else if(val=='SQLSERVER'){
          //数据源下拉框
          that.$axios({
            method:'get',
            url:that.publicAjax.extra_path+'/middle/warehouse/fromSelect'
          }).then(data=>{
            if(data.data.success==true){
              if(type=='search'){
                that.dataSource_list=data.data.data
              }else{
                that.details_form.dataSource=''
                that.dataSource_sel_list=data.data.data
              }
            }
          })
        }else if(val=='ORACLE'){
          if(type=='search'){
            that.dataSource_list=[]
          }else{
            that.details_form.dataSource=''
            that.dataSource_sel_list=[]
          }
          that.$message.warning('功能暂未开放！')
        }
      },
      //获取报表管理列表
      get_manage(){
        let that=this
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/middle/custom_function/find/list?page='+that.manage_current_page+'&limit='+that.manage_page_size,
          params:that.search_form
        }).then(data=>{
          if(data.data.success==true){
            that.list_data=data.data.data.list
            that.manage_total=data.data.data.total
            // if(that.row_first_now.length>0){
            //   that.list_data=that.row_first_now.concat(data.data.data.list)
            //   that.list_data=that.unique(that.list_data)
            // }
            if(that.add_edit=='edit'){
              that.list_data.forEach(item=>{
                if(item.id==that.row_manage_now.id){
                  that.row_manage_now=item
                }
              })
              that.db_detail_list(that.row_manage_now)
            }else{
              that.db_detail_list(that.list_data[0])
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      },
      //查询表单
      search_manage(){
        this.manage_current_page=1
        this.manage_page_size=10
        this.activeName='two'
        this.row_first_now=[]
        //获取报表管理列表
        this.get_manage()
      },
      //重置查询表单
      reset_manage(){
        this.$refs.search_form.resetFields()
        this.manage_current_page=1
        this.manage_page_size=10
        //获取报表管理列表
        this.get_manage()
      },
      //报表管理列表分页
      manage_size_change(val){
        this.manage_page_size=val
        //获取报表管理列表
        this.get_manage()
      },
      manage_current_change(val){
        this.manage_current_page=val
        //获取报表管理列表
        this.get_manage()
      },
      //报表管理列表双击事件
      manage_check_detail(row,column,event){
        this.activeName='three'
        this.db_detail_list(row)
      },
      db_detail_list(row){
        this.add_edit=''
        if(row==undefined){
          //重置子表明细当前行数据
          this.row_manage_now={}
          return false
        }
        // this.add_rules={}
        //获取报表当前行
        this.row_manage_now=row
        //报表管理明细表单禁用状态
        this.add_manage_status=false
        this.edit_manage_status=false
        this.delete_manage_status=false
        this.disable_manage_status=false
        this.save_manage_status=true
        this.cancel_manage_status=true
        //选中当前行
        this.$refs.db_detail_list.setCurrentRow(row)
        //重置明细表单校验
        this.$refs.details_form.clearValidate()
        //明细表单回显
        this.details_form.dataSourceType=row.dataSourceType
        this.details_form.dataSource=row.dataSource
        this.details_form.functionType=row.functionType
        this.details_form.executeType=row.executeType
        this.details_form.functionName=row.functionName
        this.details_form.executeName=row.executeName
        this.details_form.activeFlag=row.activeFlag
        this.details_form.orderBy=row.orderBy
        this.details_form.summaryBy=row.summaryBy
        this.details_form.configAuth=row.configAuth
        this.details_form.pageFlag=row.pageFlag
        this.details_form.pageSize=row.pageSize
        this.details_form.canExport=row.canExport
        this.details_form.sqlData=row.sqlData
        this.details_form.createBy=row.createBy
        this.details_form.createTime=row.createTime
        this.details_form.modifyBy=row.modifyBy
        this.details_form.updateTime=row.updateTime
      },
      //新增报表前置
      add_manage(){
        this.row_first_now=[]
        this.add_edit='add'
        //报表管理明细表单禁用状态
        this.add_manage_status=true
        this.edit_manage_status=true
        this.delete_manage_status=true
        this.disable_manage_status=true
        this.save_manage_status=false
        this.cancel_manage_status=false
        //重置报表明细表单
        this.$refs.details_form.resetFields()
      },
      //修改报表前置
      edit_manage(){
        this.row_first_now=[]
        this.add_edit='edit'
        //报表管理明细表单禁用状态
        this.add_manage_status=true
        this.edit_manage_status=true
        this.delete_manage_status=true
        this.disable_manage_status=true
        this.save_manage_status=false
        this.cancel_manage_status=false
        //重置入库明细表单校验
        this.$refs.details_form.clearValidate()
      },
      //新增或修改报表保存
      save_manage(){
        let that=this
        that.$refs.details_form.validate((valid)=>{
          if(valid){
            if(that.add_edit=='add'){
              that.$axios({
                method:'post',
                url:that.publicAjax.extra_path+'/middle/custom_function',
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  dataSourceType: that.details_form.dataSourceType,
                  dataSource:that.details_form.dataSource,
                  functionType:that.details_form.functionType,
                  functionTypeText:'',
                  executeType:that.details_form.executeType,
                  functionName:that.details_form.functionName,
                  executeName:that.details_form.executeName,
                  activeFlag:that.details_form.activeFlag,
                  orderBy:that.details_form.orderBy,
                  summaryBy:that.details_form.summaryBy,
                  configAuth:that.details_form.configAuth,
                  pageFlag:that.details_form.pageFlag,
                  pageSize:that.details_form.pageSize,
                  canExport:that.details_form.canExport,
                  sqlData:that.details_form.sqlData
                }
              }).then(data=>{
                if(data.data.success==true){
                  // that.row_first_now.push(data.data.data)
                  //获取报表管理列表
                  that.get_manage()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }else if(that.add_edit=='edit'){
              that.$axios({
                method:'put',
                url:that.publicAjax.extra_path+'/middle/custom_function/byId/'+that.row_manage_now.id,
                headers:{
                  "token": localStorage.getItem(localStorage.getItem('userName')+'token'),
                  "content-type":"application/json;charset=UTF-8"
                },
                data:{
                  dataSourceType: that.details_form.dataSourceType,
                  dataSource:that.details_form.dataSource,
                  functionType:that.details_form.functionType,
                  functionTypeText:'',
                  executeType:that.details_form.executeType,
                  functionName:that.details_form.functionName,
                  executeName:that.details_form.executeName,
                  activeFlag:that.details_form.activeFlag,
                  orderBy:that.details_form.orderBy,
                  summaryBy:that.details_form.summaryBy,
                  configAuth:that.details_form.configAuth,
                  pageFlag:that.details_form.pageFlag,
                  pageSize:that.details_form.pageSize,
                  canExport:that.details_form.canExport,
                  sqlData:that.details_form.sqlData
                }
              }).then(data=>{
                if(data.data.success==true){
                  // that.row_first_now.push(data.data.data)
                  //获取报表管理列表
                  that.get_manage()
                  that.$message.success(data.data.message)
                }else{
                  that.$message.warning(data.data.message)
                }
              })
            }
          }else{
            return false
          }
        })
      },
      //删除报表
      delete_manage(){
        if(this.list_data.length==0){
          this.$message.warning('暂无数据!')
          return false
        }
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'delete',
            url:that.publicAjax.extra_path+'/middle/custom_function/id/'+that.row_manage_now.id
          }).then(data=>{
            if(data.data.success==true){
              that.row_first_now=[]
              //获取报表管理列表
              that.get_manage()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{
        
        })
      },
      //禁用报表
      disable_manage(){
        this.add_edit='disable'
        let that=this
        that.$confirm('是否继续?','提示',{
          type:'warning'
        }).then(()=>{
          that.$axios({
            method:'put',
            url:that.publicAjax.extra_path+'/middle/custom_function/disable/'+that.row_manage_now.id
          }).then(data=>{
            if(data.data.success==true){
              //获取报表管理列表
              that.get_manage()
              that.$message.success(data.data.message)
            }else{
              that.$message.warning(data.data.message)
            }
          })
        }).catch(()=>{

        })
      },
      //取消新增或修改报表
      cancel_manage(){
        this.db_detail_list(this.row_manage_now)
      }
    }
  }
</script>

<style scoped="scoped">
  /* 查询表单 */
  .search_form .el-form-item{
    width: 49%;
    display: inline-block;
  }
  .details_form .el-form-item{
    width: 32%;
    display: inline-block;
  }
  @media screen and (max-width:720px) {
    .search_form .el-form-item{
      width: 100%;
    }
    .details_form .el-form-item{
      width: 49%;
    }
  }
  .search_form .el-form-item:last-child{
    width: 100%;
  }
  .details_form .form1_other{
    width: 100%;
  }
  /* 报表管理明细 */
  .operate_btn{
    margin-right: 0px;
  }
  .operate_btn+.operate_btn{
    margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/manage.vue